import styled from "styled-components";

export const Container = styled.div`
  display: none;
  opacity: 1;
  top: 0;
  box-shadow: rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border-radius: 0px;
  padding: 0.5rem;
  width: 280px;
  background-color: rgb(255, 255, 255);
  color: rgb(33, 43, 54);
  position: absolute;
  overflow: hidden auto;
  min-width: 16px;
  min-height: 16px;
  max-width: 100px;
  max-height: calc(100% - 32px);
  outline: 0px;
  transition: visibility 200ms, opacity 200ms, display 200ms;
  border-radius: 24px;
  cursor: pointer;
  &.active {
    display: block;
  }
  &:hover {
    border: 1px solid black;
    box-shadow: rgba(145, 158, 171, 0.2) 0px 0px 2px 0px,
      rgba(145, 158, 171, 0.12) 0px 12px 24px -4px;
  }
  .option_wrapper {
    img {
      width: 30px;
    }
  }

  @media only screen and (max-width: 867px) {
    transform: rotate(90deg);
  }
`;
